import React from 'react';
import { useTranslation } from '@shared/core';

import {
  Beer,
  Coffee,
  Landmark,
  Walk,
  Experiences,
  Attraction,
  Beach,
  Cocktail,
  Event,
  FoodTruck,
  Hike,
  Museum,
  Neighborhood,
  NightLife,
  Park,
  Playground,
  Restaurant,
  Sunset,
  Tour,
  Workout,
  Wine,
} from '@withjoy/joykit/icons';

export const useThingToDoCategoryUtils = () => {
  const { t } = useTranslation('guestSiteCustom');
  // to determine if these categories are strongly typed
  // we will need a similar function to map icons for each category
  const getCategoryTranslation = (category: string) => {
    switch (category) {
      case 'attraction':
        return t('thingsToDo', 'attraction')();
      case 'activity':
        return t('thingsToDo', 'activity')();
      case 'bar':
        return t('thingsToDo', 'bar')();
      case 'wineBar':
        return t('thingsToDo', 'wineBar')();
      case 'beach':
        return t('thingsToDo', 'beach')();
      case 'breakfast':
        return t('thingsToDo', 'breakfast')();
      case 'brewery':
        return t('thingsToDo', 'brewery')();
      case 'brunch':
        return t('thingsToDo', 'brunch')();
      case 'cocktailBar':
        return t('thingsToDo', 'cocktailBar')();
      case 'caffeine':
        return t('thingsToDo', 'caffeine')();
      case 'dinner':
        return t('thingsToDo', 'dinner')();
      case 'diveBar':
        return t('thingsToDo', 'diveBar')();
      case 'event':
        return t('thingsToDo', 'event')();
      case 'foodTruck':
        return t('thingsToDo', 'foodTruck')();
      case 'landmark':
        return t('thingsToDo', 'landmark')();
      case 'lateNight':
        return t('thingsToDo', 'lateNight')();
      case 'lunch':
        return t('thingsToDo', 'lunch')();
      case 'museum':
        return t('thingsToDo', 'museum')();
      case 'neighborhood':
        return t('thingsToDo', 'neighborhood')();
      case 'park':
        return t('thingsToDo', 'park')();
      case 'playground':
        return t('thingsToDo', 'playground')();
      case 'hangoutSpot':
        return t('thingsToDo', 'hangoutSpot')();
      case 'hike':
        return t('thingsToDo', 'hike')();
      case 'restaurant':
        return t('thingsToDo', 'restaurant')();
      case 'shopping':
        return t('thingsToDo', 'shopping')();
      case 'tour':
        return t('thingsToDo', 'tour')();
      case 'walk':
        return t('thingsToDo', 'walk')();
      case 'workout':
        return t('thingsToDo', 'workout')();
      default:
        return category || t('thingsToDo', 'custom')();
    }
  };

  /**
   * Returns a JoyKit icon component matching the category.
   */
  const getCategoryIcon = (category: string) => {
    switch (category) {
      case 'attraction':
        return <Attraction />;
      case 'activity':
        return <Walk />;
      case 'bar':
        return <Beer />;
      case 'wineBar':
        return <Wine />;
      case 'beach':
        return <Beach />;
      case 'breakfast':
      case 'brunch':
      case 'dinner':
      case 'lunch':
      case 'restaurant':
        return <Restaurant />;
      case 'brewery':
      case 'diveBar':
        return <Beer />;
      case 'cocktailBar':
        return <Cocktail />;
      case 'caffeine':
        return <Coffee />;
      case 'landmark':
        return <Landmark />;
      case 'neighborhood':
        return <Neighborhood />;
      case 'playground':
        return <Playground />;
      case 'hangoutSpot':
        return <Sunset />;
      case 'hike':
      case 'walk':
        return <Hike />;
      case 'workout':
        return <Workout />;
      case 'foodTruck':
        return <FoodTruck />;
      case 'lateNight':
        return <NightLife />;
      case 'event':
        return <Event />;
      case 'museum':
        return <Museum />;
      case 'park':
        return <Park />;
      case 'tour':
        return <Tour />;
      case 'shopping':
      default:
        return <Experiences />;
    }
  };

  return { getCategoryTranslation, getCategoryIcon };
};
